import { eanCheckDigit, isValidEan13, parseScaleBarcode, ScaleBarcodeFormat } from '@iws/pos-devices'

/**
 * What a scanned code is (POS.md §18.8). Pure parsing; the lookups (barcodes, customer cards, refs) are the caller's.
 * Order at the till: scale label → product barcode → customer card → receipt ref.
 */

/** EAN-13 check digit of the first 12 digits (the shared parser's, so the Flutter app reads the same codes). */
export const ean13CheckDigit = (first12: string) => eanCheckDigit(first12)

export { isValidEan13 }

/**
 * Scale label (POS.md §18.8), read with the formats of this till's scale models (`scaleFormats()`); by default `21` +
 * `plu_code` (5) + grams (5) + check digit. A price label gives `price` instead of `kg`.
 */
export const parseScaleLabel = (code: string, formats?: ScaleBarcodeFormat[]): { plu: string; kg?: number; price?: number } | null => {
  const r = parseScaleBarcode(code, formats)
  if (!r) return null
  return r.weight !== undefined ? { plu: r.plu, kg: r.weight } : { plu: r.plu, price: r.price }
}

/** `YYYY-MMDD-T<unique_no>-<counter>`: receipts (`order_ref`) and repayment slips (`receipt_no`); `-R<n>` = return slip. */
export const isRef = (code: string) => /^\d{4}-\d{4}-T\d+-\d+(-R\d+)?$/.test(code)
